import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDataLakeInsight = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-data-lake-insight';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.865 4.283c-2.146.19-3.93 1.723-4.464 3.835a8 8 0 0 0-.161 1.125c0 .028-.036.037-.093.022-.146-.036-.967.048-1.303.134a4.77 4.77 0 0 0-3.427 3.38 4.7 4.7 0 0 0-.142 1.651c.122 1.159.567 2.098 1.382 2.913s1.754 1.26 2.913 1.382c.982.102 2.101-.166 2.955-.708l.264-.168 1.335 1.335 1.335 1.336.531-.53.53-.529-1.335-1.341-1.336-1.34.168-.26a4.736 4.736 0 0 0-1.878-6.745l-.388-.195.022-.44c.044-.891.36-1.621.985-2.274a3.5 3.5 0 0 1 1.59-.972c.314-.096.419-.108.972-.11.529-.003.666.01.932.087 1.057.305 1.843.962 2.306 1.932.247.516.324.872.35 1.621l.023.645.645.023c.749.026 1.105.103 1.621.35a3.54 3.54 0 0 1 1.924 2.285c.104.368.145 1.073.084 1.461a3.66 3.66 0 0 1-1.946 2.683 3.9 3.9 0 0 1-1.254.356l-.325.025v.754c0 .652.008.754.062.754.203 0 .884-.097 1.144-.162a5.45 5.45 0 0 0 1.874-.899 7.5 7.5 0 0 0 .974-.981c.686-.907 1.088-2.238 1.007-3.338-.171-2.337-1.781-4.202-4.045-4.682l-.324-.069-.048-.265c-.114-.624-.501-1.507-.891-2.031a5.1 5.1 0 0 0-2.013-1.621c-.429-.189-.506-.216-.888-.311-.259-.065-1.2-.177-1.292-.155-.011.003-.18.019-.375.037m-3.951 6.595c.508.146.893.372 1.321.78.446.425.733.89.894 1.45.129.45.129 1.334 0 1.784-.167.582-.458 1.042-.941 1.492-.633.588-1.319.856-2.188.856s-1.555-.268-2.188-.856c-.483-.45-.774-.91-.941-1.492-.129-.45-.129-1.334 0-1.784.152-.53.375-.91.787-1.343a3.1 3.1 0 0 1 1.775-.967c.321-.058 1.152-.013 1.481.08"
    })
  }));
});
export default SvgDataLakeInsight;